export const CASES_ID = 'cases'
export const ABOUT_ID = 'about'
export const SERVICES_ID = 'services'
export const CONTACT_ID ='contact'